module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.e18bbf611f2a2e43afc0.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bootstrap/fonts/glyphicons-halflings-regular.ttf
// module id = 1193
// module chunks = 8